import React from 'react'
import Container from '../../Container/Container'

function AddComment() {
    return (
        <Container>
            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">Add Prom Order</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="card card-full">
                                <div class="card-inner">
                                    <div class="stepperLeft">
                                        <div className="row">
                                            <div className="col-md-4 brIght">
                                                <section class="section1">
                                                    <header>
                                                        <div class="bead complete"><span><i class="fa-solid fa-check"></i></span></div>
                                                        Add Prom Event
                                                    </header>
                                                </section>
                                                <section class="section2">
                                                    <header>
                                                        <div class="bead complete"><span><i class="fa-solid fa-check"></i></span></div>
                                                        Add Measured
                                                    </header>
                                                </section>
                                                <section>
                                                    <header>
                                                        <div class="bead current"><span>3</span></div>
                                                        Add Comment
                                                    </header>
                                                </section>

                                            </div>
                                            <div className="col-md-8">
                                                <h4>Add Comment</h4>
                                                <div className="inputCardBox mt-4">
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">
                                                            <label>Rental Term <span className="text-red-500">*</span></label>
                                                            <select><option>Select week</option></select>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label>Measured By  <span className="text-red-500">*</span></label>
                                                            <input class="" type="text" placeholder="Enter name" />
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label>Comments <small>( maximum 20 characters ) </small> <span className="text-red-500">*</span></label>
                                                            <textarea className="" placeholder='For Your Reference Only'></textarea>
                                                        </div>
                                                        <div class="col-md-12 mt-3">
                                                            <a href='' className="backBtnWedding">Back</a>
                                                            <button type="submit" class="addBtnCustomer">Submit</button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Container>
    )
}

export default AddComment
